import { render, staticRenderFns } from "./AdRecordGroupPanel.vue?vue&type=template&id=21199cd5&scoped=true&"
import script from "./AdRecordGroupPanel.vue?vue&type=script&lang=js&"
export * from "./AdRecordGroupPanel.vue?vue&type=script&lang=js&"
import style0 from "./AdRecordGroupPanel.vue?vue&type=style&index=0&id=21199cd5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21199cd5",
  null
  
)

export default component.exports